import {Controller, useForm} from "react-hook-form";
import {IFormConfig} from "@tpd-web-react-libs/nodejs-library/dist/src/interfaces";
import {SelfRegistrationService} from "@tpd-web-react-libs/nodejs-library/dist/src/providers";
import {Helpers} from "@tpd-web-common-libs/nodejs-library";
import {Constants} from "@tpd-web-react-libs/nodejs-library/dist/src/common";
import {UsButton, UsInput} from "@tpd-web-react-libs/nodejs-library/dist/src/components";
import React, {useState} from "react";


type TFormChangePassword = {
    username: string,
    oldPassword: string,
    newPassword: string,
    newPasswordConfirm: string,
}

export type TChangePasswordFormProps = {
    username?: string;
    oldPassword?: string;
    onLoadStart?: () => void;
    onLoadEnd?: () => void;
}

const URL = Constants.url[1];
const ERROR_MESSAGES = {
    sameOldAndNewPassword: "La nuova password e' uguale alla vecchia password",
    passwordError: "Password non valida. Soddisfare tutte le condizioni richieste",
    confirmPasswordError: "La conferma non è uguale alla password inserita",
};
const REG_EXP = {
    passwordAllowedChars: /^[\x21-\x7E]+$/,
};

export const ChangePasswordForm = (props: TChangePasswordFormProps) => {
    const {
        control,
        handleSubmit,
        watch,
        formState,
        getValues,
        resetField,
        getFieldState
    } = useForm<TFormChangePassword>({mode: "onChange"});

    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const validatePassword = async (password: string): Promise<boolean> => {
        return new Promise(resolve => {
            if (REG_EXP.passwordAllowedChars.test(password)) {
                SelfRegistrationService.validatePassword(password)
                    .then(() => {
                        resolve(true)
                    })
                    .catch(() => {
                        resolve(false);
                        // resetField("newPasswordConfirm");
                    });
            } else {
                resolve(false);
                // setPasswordErrorMessage("Password non valida. Sono stati inseriti caratteri non validi.");
                // resetField("newPasswordConfirm");
            }
        })
    }

    const checkConfirmPassword = () => {
        const {newPassword, newPasswordConfirm} = getValues();
        if (newPassword !== newPasswordConfirm) resetField("newPasswordConfirm");
    }


    const formConfig: IFormConfig = {
        newPassword: {
            name: "newPassword",
            placeholder: "Inserisci la nuova password scelta",
            type: "password",
            defaultValue: "",
            rules: {
                required: true,
                minlength: 8,
                validate: validatePassword,
            },
        },
        newPasswordConfirm: {
            name: "newPasswordConfirm",
            placeholder: "Inserisci nuovamente la password",
            type: "password",
            defaultValue: "",
            rules: {
                validate: (value: string) => watch('newPassword') === value,
            }
        },
    }

    const {invalid: isNewPasswordInvalid} = getFieldState("newPassword", formState);
    const {invalid: isNewPasswordConfirmInvalid} = getFieldState("newPasswordConfirm", formState);
    const {isValid} = formState;


    const submitForm = () => {
        const model = {
            username: props.username,
            oldPassword: props.oldPassword,
            newPassword: getValues("newPassword"),
        }

        setErrorMessage(null);

        if (model.newPassword === model.oldPassword) {
            setErrorMessage(ERROR_MESSAGES.sameOldAndNewPassword);
            return;
        }

        props.onLoadStart();
        // validazione della nuova password lato server
        SelfRegistrationService.validatePassword(model.newPassword)
            .then(() => {

                // se passo la validazione chiamo il servizio per modificare la password
                SelfRegistrationService
                    .modifyPassword(model.username, model.oldPassword, model.newPassword)
                    .then(() => {
                        props.onLoadEnd();
                        if (typeof window === "object") {
                            Helpers.RouterHelper.goTo(URL.login + "?changePswdOk=true", {
                                openNewTab: false,
                            });
                        }
                    })
                    .catch((problem) => {
                        setErrorMessage(problem.message);
                        props.onLoadEnd();
                    });
            })
            .catch(() => {
                props.onLoadEnd();
            });
    }


    return (
        <>
            {/* FORM */}
            <div className="us-row login-dropdown_btn_wrapper">
                <form onSubmit={handleSubmit(submitForm)}>
                    <div
                        className="login-dropdown_btn col-xs-22 col-xs-offset-1 col-md-11 col-md-offset-1 col-lg-14 col-lg-offset-2">
                        <Controller
                            control={control}
                            {...formConfig.newPassword}
                            render={({field, fieldState}) => (
                                <UsInput
                                    // unbluCapturingHint="block"
                                    className="login-dropdown_input"
                                    config={formConfig.newPassword}
                                    {...formConfig.newPassword}
                                    {...field}
                                    {...fieldState}
                                    onBlur={checkConfirmPassword}
                                />
                            )}
                        />
                    </div>

                    <div className="col-xs-22 col-xs-offset-1 col-md-11 col-md-offset-1 col-lg-14 col-lg-offset-2">
                        <div className="expiredPassword">
                            La password deve avere lunghezza minima di 8 caratteri e
                            rispettare almeno 3 delle 4 caratteristiche seguenti: almeno un
                            carattere maiuscolo, uno minuscolo, una cifra o uno dei seguenti
                            caratteri speciali (! &quot; # $ % &amp; ' ( ) * + , - . / : ;
                            &lt; = &gt; ? @ [ \ ] ^ _ ` {"{"} | {"}"} ~)
                            <br/>
                            Non possono essere riutilizzate le ultime 5 password.
                        </div>
                    </div>

                    <div
                        className="login-dropdown_btn col-xs-22 col-xs-offset-1 col-md-12 col-md-offset-0 col-lg-14 col-lg-offset-2">
                        <Controller
                            control={control}
                            {...formConfig.newPasswordConfirm}
                            render={({field, fieldState}) => (
                                <UsInput
                                    // unbluCapturingHint="block"
                                    className="login-dropdown_input"
                                    config={formConfig.newPasswordConfirm}
                                    {...formConfig.newPasswordConfirm}
                                    {...field}
                                    {...fieldState}
                                />
                            )}
                        />
                    </div>

                    {/* ERRORS */}
                    {!isValid && (
                        <div
                            className="login-dropdown_error_message col-xs-22 col-xs-offset-1 col-md-22 col-md-offset-1 col-lg-14 col-lg-offset-2">
                            {isNewPasswordInvalid ? ERROR_MESSAGES.passwordError : isNewPasswordConfirmInvalid ? ERROR_MESSAGES.confirmPasswordError : ''}
                        </div>
                    )}

                    {/* SUBMIT */}
                    <div className="col-xs-22 col-xs-offset-1 col-md-22 col-md-offset-1 col-lg-14 col-lg-offset-2">
                        <UsButton disabled={!isValid} type="submit">
                            Procedi
                        </UsButton>
                    </div>

                </form>

                {/* ERRORS */}
                {errorMessage && (
                    <div
                        className="login-dropdown_error_message_2 col-xs-22 col-xs-offset-1 col-md-11 col-md-offset-1 col-lg-14 col-lg-offset-2">
                        {errorMessage}
                    </div>
                )}
            </div>
        </>
    )
}

ChangePasswordForm.defaultProps = {}